import Qs from "qs"

export default function appletOrConnectionPath(resource, extraParams) {
  const namespace = { static: "/applets", dynamic: "/connections" }
  const path = namespace[resource.config_type] || "/applets"
  const params = extraParams ? `?${Qs.stringify(extraParams)}` : ""

  return resource.friendly_id
    ? `${path}/${resource.friendly_id}${params}`
    : `${path}/${resource.id}${params}`
}
